import type { ComponentType } from 'react'

/** @jsxImportSource @emotion/react */
import type { css } from '@emotion/react'

import type { ArticleIconButtonComponent, LinkUrl } from '@twisto/api-cms'
import {
  IconButton as Button,
  TextButton,
} from '@twisto/components/atoms/button'
import * as InlineSvgIcons from '@twisto/icons/inline'
import type { SvgProps } from '@twisto/icons/types'
import { createSvgIconFromGenerated } from '@twisto/icons/utils'

import { getLinkUrl } from 'homepage/utils'

import { iconButton } from './button.styles'

type IconButtonProps = {
  styles?: ReturnType<typeof css>
}

export const IconButton = ({
  iconName,
  url,
  background,
  text,
  variant,
  styles,
}: ArticleIconButtonComponent & IconButtonProps) => {
  const link = getLinkUrl({ url } as LinkUrl)

  const svg = iconName && InlineSvgIcons[iconName]
  const icon = createSvgIconFromGenerated(
    svg as ComponentType<SvgProps>,
    iconName || ''
  )

  if (!text) {
    return <Button color={background} href={link} icon={icon} />
  }

  const RenderIcon = icon

  return (
    <div css={[iconButton, styles]}>
      <TextButton color={background} href={link} variant={variant || 'default'}>
        <RenderIcon />
        {text}
      </TextButton>
    </div>
  )
}
